import { ProductVariant } from '../models/config-strip-state.models';

export const isNeverAvailableVariant = (variant: ProductVariant): boolean =>
  (variant.children ?? [])
    .map((size) => size.inventoryItems ?? [])
    .every((inventoryItems) => !inventoryItems.length);
